<app-card
	cardTitle
	cardClass="card-datatable"
	[options]="false">
	<form
		(ngSubmit)="search()"
		class="filterform">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group d-flex flex-row">
					<input
						type="text"
						class="form-control d-inline"
						name="keyword"
						placeholder="Cerca..."
						[(ngModel)]="searchparams.genericSearchTerm">
					<button
						type="button"
						class="btn btn-link ml-2"
						(click)="toggleAdvanced()">
						<i class="feather icon-filter"></i>

					</button>
				</div>
			</div>

		</div>
		<div [ngbCollapse]="!showAdvancedSearch">
			<div class="row">
				<!-- start -->
				<div class="col-md-6 mb-1 value-col">
					<label>{{'labels.startdate' | translate}}</label>
					<div class="row">
						<div class="col-md-2">{{'labels.from' | translate}}:</div>
						<div class="col-md-4">

							<app-datepicker
								[(ngModel)]="start.from"
								name="startfrom"
								[ngClass]="{'is-invalid': submitted && startfrominvalid}"></app-datepicker>
						</div>
						<div class="col-md-2">{{'labels.to' | translate}}:</div>
						<div class="col-md-4">
							<app-datepicker
								[(ngModel)]="start.to"
								name="startto"
								[ngClass]="{'is-invalid': submitted && starttoinvalid}"
								[disabled]="!start.from"
								[min]="start.from"></app-datepicker>
						</div>
					</div>
				</div>
				<!-- stop -->
				<div class="col-md-6 mb-1 value-col">
					<label>{{'labels.stopdate' | translate}}</label>
					<div class="row">
						<div class="col-md-2">{{'labels.from' | translate}}:</div>
						<div class="col-md-4">

							<app-datepicker
								[(ngModel)]="stop.from"
								name="stopfrom"
								[ngClass]="{'is-invalid': submitted && stopfrominvalid}"></app-datepicker>
						</div>
						<div class="col-md-2">{{'labels.to' | translate}}:</div>
						<div class="col-md-4">
							<app-datepicker
								[(ngModel)]="stop.to"
								name="stopto"
								[ngClass]="{'is-invalid': submitted && stoptoinvalid}"
								[disabled]="!stop.from"
								[min]="stop.from"></app-datepicker>
						</div>
					</div>
				</div>
			</div>

		</div>
		<div class="row mt-1">
			<div class="col">
				<button
					type="submit"
					class="btn btn-primary">
					{{'labels.search' | translate}}
				</button>
				<a
					(click)="resetSearch()"
					class="btn btn-default">
					{{'labels.reset' | translate}}
				</a>
			</div>

		</div>
	</form>
</app-card>
